import React from "react";
import {useAtom, useCtx} from '@reatom/npm-react'
import {addBlankParticipant, getModelAtom, participantsAtom, shuffleParticipants} from '../model'

import './style.css'
import MembersItem from './MembersItem'
import SvgSprite from "../../Utils/SvgSprite";
import {motion, AnimatePresence} from 'motion/react'

import MotionItem from "../../Utils/Motions/MotionItem";

function MembersList({}) {

  const ctx = useCtx()
  const [participants] = useAtom(participantsAtom)

  const [group_count] = useAtom(getModelAtom('tournament.group_count'))

  function shuffle() {
    shuffleParticipants(ctx)
  }

  function addBlank() {
    addBlankParticipant(ctx)
  }

  return (
    <div className="members-list">
      {participants.length > 0 && (
        <div className="members-list-item members-list__heading">
          <div className="base-form-field members-list__label">
            {gettext('Посев')}
          </div>
          {!!group_count && (
            <div className="base-form-field  members-list__label">
              {gettext('Группа')}
            </div>
          )}
          <div className="members-list-item__player"></div>
          <div className="members-list-item__actions members-list__icon-button" onClick={shuffle}>
            <SvgSprite id="shuffle"/>
          </div>
        </div>
      )}
      <div className="members-list__list">
        <AnimatePresence initial={false}>
          {participants.map((item, i) => (
            <MotionItem
              key={item.id}
              children={
                <MembersItem
                  key={item.id}
                  // key={i}
                  num={i}
                  source={item}
                  has_group={!!group_count}
                />
              }/>

          ))}
        </AnimatePresence>
      </div>
      <div className="members-list__buttons">
        <div className="button -link" onClick={addBlank}>
          <SvgSprite id="add_user"/>
          Добавить участников
        </div>
      </div>
    </div>
  )
}

export default MembersList